module.exports = __webpack_public_path__ + "img/cross-motor.65fd0a2c.svg";